export class ProspectTourLocation {
    constructor (
        public ProspectSelfTourKey: string = null,
        public Latitude: string = null,
        public Longitude: string = null,
    ) { }
}
